import { FC } from "react";
import { SplitButton } from "../../../../../../TrueUI";
import { ButtonsForBillingActivityTableProps } from "../TypesBillingActivityTable";

export const ButtonsBillingActivityTable: FC<
  ButtonsForBillingActivityTableProps
> = ({
  openPaymentSelectorModal,
  setModalConfigForNewEntryAction,
  hasPermission,
  billingActivityTotals,
}) => {
  const isButtonDisabled = hasPermission === true ? false : true;
  const splitButtonItems = [
    {
      option: "NEW PAYMENT",
      dropdownText: "NEW PAYMENT",
      action: () => openPaymentSelectorModal(),
    },
    {
      option: "NEW ENTRY",
      dropdownText: "NEW ENTRY",
      action: () =>
        setModalConfigForNewEntryAction({
          showModalBillingItem: true,
          activityType: "new_entry",
        }),
    },
  ];
  return (
    <>
      <SplitButton
        items={splitButtonItems}
        disabledItems={isButtonDisabled === true ? [1] : []}
      />
      {billingActivityTotals}
    </>
  );
};

export default ButtonsBillingActivityTable;
